import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectActivatedFireId } from "features/map/control/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { useRouter } from "pages"
import { ReactElement } from "react"
import { useLocation } from "react-router"
import { selectGlobalModal } from "runlevel/selectors"

type OverlayPanelContainerProps = {
    children?: ReactElement
}

export default function OverlayPanelContainer({ children }: OverlayPanelContainerProps) {
    const location = useLocation()
    const router = useRouter("/")
    const workspaceId = useAppSelector(selectActiveWorkspaceId()) || ""
    const projectId = useAppSelector(selectActivatedFireId) || ""
    const isInProject =
        router.preview({
            path: "/workspace/:workspaceId/project/:projectId",
            params: { workspaceId, projectId },
        }) === location.pathname
    const isShowingGlobalModal = useAppSelector(selectGlobalModal)

    if (!(isInProject || isShowingGlobalModal)) {
        return null
    }

    return <div id="overlay-panel-container">{children}</div>
}
